var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLobbyWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lobby_white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.545,
    height: 56.545,
    viewBox: "0 0 56.545 56.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M217.193,348.036a1.353,1.353,0,1,0,.956-.4A1.354,1.354,0,0,0,217.193,348.036Z",
    transform: "translate(-192.503 -308.685)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M438.826,393.55a1.355,1.355,0,1,0,.956.4A1.355,1.355,0,0,0,438.826,393.55Z",
    transform: "translate(-389.586 -349.451)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M55.44,29.378H50.578V20.112a5.541,5.541,0,0,0-4.323-5.38l-3.61-.792a5.78,5.78,0,0,0,2.027-4.4V5.794a5.794,5.794,0,1,0-11.587,0V9.546a5.779,5.779,0,0,0,2.023,4.393l-3.61.791a5.541,5.541,0,0,0-4.327,5.38v4.849H21.2a1.106,1.106,0,0,0-1.1,1.1v3.314H12.37V26.285h4.637a1.1,1.1,0,0,0,1.1-1.1V13.253a1.1,1.1,0,0,0-1.1-1.1H1.1a1.1,1.1,0,0,0-1.1,1.1V25.181a1.1,1.1,0,0,0,1.1,1.1H5.742v3.093H1.1a1.1,1.1,0,0,0-1.1,1.1v5.3a1.1,1.1,0,0,0,1.1,1.1H4.863V55.44a1.1,1.1,0,0,0,1.1,1.1H50.582a1.1,1.1,0,0,0,1.1-1.1V50.029a1.1,1.1,0,0,0-2.209,0v4.308H7.068V41.523H21.2a1.1,1.1,0,1,0,0-2.209H7.068V36.887H49.477v4.308a1.1,1.1,0,0,0,2.209,0V36.887H55.44a1.1,1.1,0,0,0,1.1-1.1v-5.3a1.1,1.1,0,0,0-1.1-1.1ZM35.29,8.763h1.52a10.159,10.159,0,0,0,5.655-1.7V9.546a3.585,3.585,0,1,1-7.17,0Zm3.585,6.576a5.8,5.8,0,0,0,1.008-.089l-1.018,2.3-1.023-2.306A5.808,5.808,0,0,0,38.875,15.34Zm0-13.131A3.591,3.591,0,0,1,42.205,4.47a7.966,7.966,0,0,1-5.4,2.089H35.29V5.794A3.589,3.589,0,0,1,38.875,2.209Zm-9.5,17.9a3.317,3.317,0,0,1,2.591-3.222l3.811-.836,2.073,4.667a1.1,1.1,0,0,0,2.019,0l2.073-4.668,3.835.839a3.316,3.316,0,0,1,2.593,3.222v9.266H36.446V26.064a1.106,1.106,0,0,0-1.1-1.1H29.378Zm-7.068,7.058H34.236v2.21H22.309ZM2.209,14.363H15.9v9.719H12.352a3.314,3.314,0,0,0-6.592,0H2.209ZM7.951,24.428a1.1,1.1,0,1,1,2.209,0v4.961H7.951ZM54.337,34.689H2.209v-3.1H54.337Z",
    transform: "translate(0)",
    fill: "#f5f5f5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLobbyWhite);
export default __webpack_public_path__ + "static/media/Lobby_white.d58b487345e128a62772a43cc88da4b5.svg";
export { ForwardRef as ReactComponent };